/*
 * ===============================================================================================================
 *                                Copyright 2025, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { GET_AUTH_DETAILS, SHOW_AUTH_ERROR } from './types';

export const getAuthDetailsAction = (assignedPermissions: any) => {
  return {
    type: GET_AUTH_DETAILS,
    assignedPermissions: assignedPermissions,
  };
};

export const showAuthDetailsError = (error: any) => {
  return {
    type: SHOW_AUTH_ERROR,
    errorMessage: error?.response?.data.message
  };
};
